import Vue from 'vue'
import App from './App.vue'
import 'babel-polyfill'
import 'vant/lib/index.css';
import router from './router'
import i18n from './i18n/index'
//import ElementUI from './config/elementConfig.js'
//import VueClipboard from 'vue-clipboard2'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
// import {
//   InfiniteScroll
// } from 'mint-ui'
import './config/mint-variables.css'
require('es6-promise').polyfill()
require('isomorphic-fetch')
import './assets/css/base.css'
import filters from './assets/js/filters'
// import '@/assets/js/flexible.js'
// import '@/assets/js/flexible_css.js'
// import '@/assets/css/app.scss'

Vue.config.productionTip = false

// Vue.use(InfiniteScroll)
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]) //注册全局filter；
})

// Vue.prototype.$menuVisible = false;
window.globalStore = new Vue({
  data: {
    menuVisible: false
  }
});

router.afterEach(() => {
  NProgress.done();
})

new Vue({
  router,
  i18n,
  render: h => h(App),
  //这里与vue.config.js中的事件名相对应
  mounted () {
  }
}).$mount('#app')